import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { Language } from '@mui/icons-material';

export function BasicSelect() {
    const { i18n } = useTranslation();
    let lng = i18next.language;

    const toggleLanguage = () => {
        const otherLng = lng === 'en' ? 'ar' : 'en';
        i18n.changeLanguage(otherLng);
    };

    return (
        <Box
            onClick={toggleLanguage}
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                cursor: 'pointer',
                color: '#1A1A1A',
                '&:hover': { color: '#C59850' },
            }}
        >
            <Language sx={{ fontSize: 20 }} />
            <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
                {lng === 'ar' ? 'EN' : 'العربية'}
            </Typography>
        </Box>
    );
}
